<template>
    <div class="cursor-pagination">
        <nav class="cursor-pagination__nav">
            <vx-button
                data-test="cursor-pagination-first"
                data-router="client-route"
                appearance="primary-dark-outline"
                size="medium"
                :left="pending(firstPage) ? 'spinner' : 'chevron-double-left-bold'"
                :has-shadow="true"
                :href="isFirstPageDisabled ? '' : firstPage"
                :disabled="isFirstPageDisabled"
                @click.prevent="loadUrl(firstPage)"
                >First</vx-button
            >

            <vx-button
                data-test="cursor-pagination-prev"
                data-router="client-route"
                appearance="primary-dark-outline"
                size="medium"
                :left="pending(prevPage) ? 'spinner' : 'chevron-left-bold'"
                :has-shadow="true"
                :href="isPrevPageDisabled ? '' : prevPage"
                :disabled="isPrevPageDisabled"
                @click.prevent="loadUrl(prevPage)"
                >Prev</vx-button
            >

            <vx-button
                data-test="cursor-pagination-next"
                data-router="client-route"
                appearance="primary-dark-outline"
                size="medium"
                :right="pending(nextPage) ? 'spinner' : 'chevron-right-bold'"
                :has-shadow="true"
                :href="isNextPageDisabled ? '' : nextPage"
                :disabled="isNextPageDisabled"
                @click.prevent="loadUrl(nextPage)"
                >Next</vx-button
            >
            <vx-button
                data-test="cursor-pagination-last"
                data-router="client-route"
                appearance="primary-dark-outline"
                size="medium"
                :right="pending(lastPage) ? 'spinner' : 'chevron-double-right-bold'"
                :has-shadow="true"
                :href="isLastPageDisabled ? '' : lastPage"
                :disabled="isLastPageDisabled"
                @click.prevent="loadUrl(lastPage)"
                >Last</vx-button
            >
        </nav>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { VxButton } from '@voxie/frontend-components-v3';
import { getCursorFromHash, getCursorFromURL } from '../../composables/useClientRoutes';

const props = defineProps({
    cursor: String,
    firstPage: String,
    prevPage: String,
    nextPage: String,
    lastPage: String,
    loading: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:cursor', 'change']);

const currentUrl = ref(null);

const isFirstPageDisabled = computed(() => !props.firstPage || !props.prevPage || isPageLinkDisabled(props.firstPage));
const isPrevPageDisabled = computed(
    () => !props.prevPage || isPageLinkDisabled(props.prevPage) || isPageLinkDisabled(props.firstPage)
);
const isNextPageDisabled = computed(
    () => !props.nextPage || isPageLinkDisabled(props.nextPage) || isPageLinkDisabled(props.lastPage)
);
const isLastPageDisabled = computed(() => !props.lastPage || !props.nextPage || isPageLinkDisabled(props.lastPage));

const loadUrl = (url) => {
    currentUrl.value = url;

    const cursor = getCursorFromURL(url);

    emit('update:cursor', cursor);
    emit('change', cursor);
};

const pending = (url) => props.loading && currentUrl.value === url;

const isPageLinkDisabled = (pageLink) => (pageLink ? getCursorFromHash('pages') === getCursorFromURL(pageLink) : false);
</script>

<style lang="scss">
.cursor-pagination {
    margin: 10px 0;
}

.cursor-pagination__nav {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    padding: 15px 0;

    .vx-button {
        border-radius: 6px;
    }
}
</style>
